module.exports = __webpack_public_path__ + "static/media/logo_sismart.f3d61739.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_sismart.png
// module id = 1609
// module chunks = 0